// @ts-nocheck
import { Box, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { colorReasonArray } from "../../utils/methods/eventUtils";
import { isUserRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import PropTypes from "prop-types";

export const DashboardColorExplanation = ({
  colorReasons = colorReasonArray,
  title = "Colors?",
}) => {
  const isSmallerScreen = useMediaQuery((theme) =>
    theme?.breakpoints?.down("sm"),
  );

  if (isSmallerScreen) return null;

  if (!isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)) return null;

  return (
    <Tooltip
      arrow
      title={
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.75rem",
            padding: "0.75rem",
          }}
        >
          {colorReasons?.map((item, index) => {
            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Box
                  sx={{
                    height: "30px",
                    aspectRatio: 1,
                    backgroundColor: item?.color,
                    borderRadius: "0.5rem",
                  }}
                ></Box>
                <Typography>{item?.reason}</Typography>
              </Box>
            );
          })}
        </Box>
      }
    >
      <Typography
        sx={{
          display: "inline",
          cursor: "pointer",
          mx: 1,
          padding: "0.25rem 0.5rem",
        }}
      >
        {title.split("").map((char, index) => (
          <span
            key={index}
            style={{
              color: colorReasonArray[index % colorReasonArray.length]?.color,
            }}
          >
            {char}
          </span>
        ))}
        {/* Colors? */}
      </Typography>
    </Tooltip>
  );
};

DashboardColorExplanation.propTypes = {
  colorReasons: PropTypes.array,
  title: PropTypes.string,
};